import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type ProductHeadGenericLabelProps = ComponentPropsWithoutRef<'button'> & {
  hasBorder?: boolean
}

export const ProductHeadGenericLabel: FC<ProductHeadGenericLabelProps> = ({
  className,
  hasBorder = true,
  ...rest
}) => (
  <button
    className={clsx(
      className,
      hasBorder && 'border px-2 py-1',
      !hasBorder && 'px-2.5 py-1.5',
      'mb-2.5 mr-2.5 flex items-center rounded-full text-xs',
      !rest.onClick && 'cursor-default',
    )}
    type="button"
    {...rest}
  />
)
